/**
 * Created by Administrator on 2018/3/8.
 */
const state = {
  loginVisible: false,
  projectId: '',
  itemObj1: {},
  itemObj2: {},
  groupObj: {},
  pointObj1: {},
  pointObj2: {},
  pointCheckList: [],
  groupCheckList: [],
  startDate: '',
  endDate: '',
  dateCheck: false,
  groupCheck: false,
  pointCheck: false,
  statusCheck: ['监测中'],//项目状态
  infoPath: '/project/situationInfo/realTime',
  editPath: '/project/edit/list',
  managePath: '/project/manage/device/imcList',
};
const mutations = {
  SET_LOGIN_VISIBLE (state, check) {
    state.loginVisible = check;
  },
  SET_ITEM_1(state, obj){
    state.itemObj1 = obj;
    window.session.setObj(window.sessionKeys.MONITORITEM1, obj);
  },
  CLEAR_ITEM_1(state){
    state.itemObj1 = {};
    window.session.remove(window.sessionKeys.MONITORITEM1);
  },
  SET_ITEM_2(state, obj){
    state.itemObj2 = obj;
    window.session.setObj(window.sessionKeys.MONITORITEM2, obj);
  },
  CLEAR_ITEM_2(state){
    state.itemObj2 = {};
    window.session.remove(window.sessionKeys.MONITORITEM2);
  },
  SET_GROUP(state, obj){
    state.groupObj = obj;
    window.session.setObj(window.sessionKeys.POINTGROUP, obj);
  },
  CLEAR_GROUP(state){
    state.itemObj2 = {};
    window.session.remove(window.sessionKeys.POINTGROUP);
  },
  SET_POINT_1(state, obj){
    state.pointObj1 = obj;
    window.session.setObj(window.sessionKeys.MONITORPOINT1, obj);
  },
  SET_POINT_CHECK_LIST(state, arr){
    state.pointCheckList = arr;
    window.session.setObj(window.sessionKeys.POINTCHECKLIST, arr);
  },
  SET_GROUP_CHECK_LIST(state, arr){
    state.groupCheckList = arr;
    window.session.setObj(window.sessionKeys.GROUPCHECKLIST, arr);
  },
  SET_SENSOR_1(state, obj){
    state.sensorObj1 = obj;
    window.session.setObj(window.sessionKeys.SENSORDEVICE1, obj);
  },
  CLEAR_POINT_1(state){
    state.pointObj1 = {};
    window.session.remove(window.sessionKeys.MONITORPOINT1);
  },
  SET_POINT_2(state, obj){
    state.pointObj2 = obj;
    window.session.setObj(window.sessionKeys.MONITORPOINT2, obj);
  },
  CLEAR_POINT_2(state){
    state.pointObj2 = {};
    window.session.remove(window.sessionKeys.MONITORPOINT2);
  },
  CLEAR_POINT_CHECK(state){
    state.pointCheckList = [];
    window.session.remove(window.sessionKeys.POINTCHECKLIST);
  },
  CLEAR_GROUP_CHECK(state){
    state.groupCheckList = [];
    window.session.remove(window.sessionKeys.GROUPCHECKLIST);
  },
  SET_START_DATE(state, obj){
    state.startDate = obj;
  },
  SET_END_DATE(state, obj){
    state.endDate = obj;
  },
  SET_DATE_CHECK(state, check){
    state.dateCheck = check;
  },
  SET_POINT_CHECK(state, check){
    state.pointCheck = check;
  },
  SET_GROUP_CHECK(state, check){
    state.groupCheck = check;
  },
  SET_STATUS_ARR(state, check){
    state.statusCheck = check;
  },
  SET_INFO_PATH(state, check){
    state.infoPath = check;
  },
  SET_EDIT_PATH(state, check){
    state.editPath = check;
  },
  SET_MANAGE_PATH(state, check){
    state.managePath = check;
  },
};
const actions = {
  setLoginVisible ({commit}, obj) {
    commit('SET_LOGIN_VISIBLE', obj);
  },
  setItemObj1({commit}, obj){
    commit('SET_ITEM_1', obj);
  },
  clearItemObj1({commit}){
    commit('CLEAR_ITEM_1');
  },
  setItemObj2({commit}, obj){
    commit('SET_ITEM_2', obj);
  },
  clearItemObj2({commit}){
    commit('CLEAR_ITEM_2');
  },
  setGroupObj({commit}, obj){
    commit('SET_GROUP', obj);
  },
  clearGroupObj({commit}){
    commit('CLEAR_GROUP');
  },
  setPointObj1({commit}, obj){
    commit('SET_POINT_1', obj);
  },
  setPointCheckList({commit}, arr){
    commit('SET_POINT_CHECK_LIST', arr);
  },
  setGroupCheckList({commit}, arr){
    commit('SET_GROUP_CHECK_LIST', arr);
  },
  setSensorObj1({commit}, obj){
    commit('SET_SENSOR_1', obj);
  },
  clearPointObj1({commit}){
    commit('CLEAR_POINT_1');
  },
  setPointObj2({commit}, obj){
    commit('SET_POINT_2', obj);
  },
  clearPointObj2({commit}){
    commit('CLEAR_POINT_2');
  },
  clearPointCheck({commit}){
    commit('CLEAR_POINT_CHECK');
  },
  clearGroupCheck({commit}){
    commit('CLEAR_GROUP_CHECK');
  },
  setStartDate({commit}, obj){
    commit('SET_START_DATE', obj);
  },
  setEndDate({commit}, obj){
    commit('SET_END_DATE', obj);
  },
  setDateCheck({commit}, obj){
    commit('SET_DATE_CHECK', obj);
  },
  setPointCheck({commit}, obj){
    commit('SET_POINT_CHECK', obj);
  },
  setGroupCheck({commit}, obj){
    commit('SET_GROUP_CHECK', obj);
  },
  setStatusArr({commit}, arr){
    commit('SET_STATUS_ARR', arr);
  },
  setInfoPath({commit}, str){
    commit('SET_INFO_PATH',str);
  },
  setEditPath({commit}, str){
    commit('SET_EDIT_PATH',str);
  },
  setManagePath({commit}, str){
    commit('SET_MANAGE_PATH',str);
  }
};
const getters = {
  getLoginVisible(state){
    return state.loginVisible;
  },
  getItemObj1(state){
    return state.itemObj1 && state.itemObj1.hasOwnProperty('id ') ?
      state.itemObj1 :
      window.session.getObj(window.sessionKeys.MONITORITEM1);
  },
  getItemObj2(state){
    return state.itemObj2 && state.itemObj2.hasOwnProperty('id ') ?
      state.itemObj2 :
      window.session.getObj(window.sessionKeys.MONITORITEM2);
  },
  getGroupObj(state){
    return state.groupObj && state.groupObj.hasOwnProperty('id ') ?
      state.groupObj :
      window.session.getObj(window.sessionKeys.POINTGROUP);
  },
  getPointObj1(state){
    return state.pointObj1 && state.pointObj1.hasOwnProperty('id ') ?
      state.pointObj1 :
      window.session.getObj(window.sessionKeys.MONITORPOINT1);
  },
  getPointCheckList(state){
    return state.pointCheckList && state.pointCheckList.length > 0 ?
      state.pointCheckList :
      window.session.getObj(window.sessionKeys.POINTCHECKLIST);
  },
  getGroupCheckList(state){
    return state.groupCheckList && state.groupCheckList.length > 0 ?
      state.groupCheckList :
      window.session.getObj(window.sessionKeys.GROUPCHECKLIST);
  },
  getSensorObj1(state){
    return state.sensorObj1 && state.sensorObj1.hasOwnProperty('id ') ?
      state.sensorObj1 :
      window.session.getObj(window.sessionKeys.SENSORDEVICE1);
  },
  getPointObj2(state){
    return state.pointObj2 && state.pointObj2.hasOwnProperty('id ') ?
      state.pointObj2 :
      window.session.getObj(window.sessionKeys.MONITORPOINT2);
  },
  getStartDate(state){
    return state.startDate;
  },
  getEndDate(state){
    return state.endDate;
  },
  getDateCheck(state){
    return state.dateCheck;
  },
  getPointCheck(state){
    return state.pointCheck;
  },
  getGroupCheck(state){
    return state.groupCheck;
  },
  getStatusArr(state) {
    return state.statusCheck;
  },
  getInfoPath(state) {
    return state.infoPath;
  },
  getEditPath(state) {
    return state.editPath;
  },
  getManagePath(state) {
    return state.managePath;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/managers/vuex/modules/situation.js